import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {MatButton} from '@angular/material/button';
import {RectangularButtonComponent} from '@aviary/buttons/base/rectangular-button/rectangular-button.component';
import {ROUTE_NAME_CAPABLE_BUTTON_COMPONENT} from '@aviary/injection-tokens/aviary-only.tokens';
import {MatTooltip} from '@angular/material/tooltip';
import {BaseNamedRouterLinkDirective} from '@aviary/directives/base-named-router-link.directive';
import {NgTemplateOutlet} from '@angular/common';
import {RectangularButtonContentComponent} from '@aviary/buttons/base/rectangular-button-content/rectangular-button-content.component';

@Component({
  selector: 'mx-outlined-button',
  templateUrl: './outlined-button.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {provide: ROUTE_NAME_CAPABLE_BUTTON_COMPONENT, useExisting: OutlinedButtonComponent}
  ],
  imports: [MatButton, MatTooltip, BaseNamedRouterLinkDirective, NgTemplateOutlet, RectangularButtonContentComponent]
})
export class OutlinedButtonComponent extends RectangularButtonComponent {
  // See BaseButtonComponent and RectangularButtonComponent for the rest of the available inputs.
  @Input() public color: string = this.config.defaultColors.outlined;
}
